import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

import type { AppPlazaListQuery, AppPlazaListResponse } from './types';

const appPlazaListUrl = () => `${PREFIX.vapis_dc_ws(GROUPS.ophub)}/artifacts`;

/** 查询当前数据中心/租户上下文下的应用广场列表 */
export function getAppPlazaList(params: AppPlazaListQuery) {
  return get<AppPlazaListResponse>(appPlazaListUrl(), { artifactType: 'ai_application', ...params });
}
